// extracted by mini-css-extract-plugin
export default {"block":"Y0OyCM","block__direction":"Gh5qDm"};